import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenu} from '@Components/contextual-menu';
import {ContextualMenuHeader} from '@Components/contextual-menu/components/contextual-menu-header';
import {ContextualMenuTextHeader} from '@Components/contextual-menu/components/contextual-menu-text-header';
import {GroupItemsDefaultOptions} from '@Components/poster-editor/components/poster-editing-side-panel/components/group-items-default-options';
import {ContextualMenuHeadingOption} from '@Components/contextual-menu/components/contextual-menu-heading-option';
import {GroupItemsSpacingOptions} from '@Components/poster-editor/components/poster-editing-side-panel/components/group-items-spacing-options';
import {ItemAlignmentOptions} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-alignment-options';
import {GroupItemsAlignmentOptions} from '@Components/poster-editor/components/poster-editing-side-panel/components/group-items-alignment-options';

export function GroupItemsContextualOptions(): ReactElement<any> | null {
  const getHeader = (): ReactElement<any> => {
    return (
      <ContextualMenuHeader id="group-items-header-option">
        <ContextualMenuTextHeader text={window.i18next.t('pmwjs_group')} />
      </ContextualMenuHeader>
    );
  };

  return (
    <ContextualMenu id="group-items" header={getHeader()}>
      <GroupItemsDefaultOptions />
      <ContextualMenuHeadingOption id="alignment-group-heading-option" text={window.i18next.t('pmwjs_alignment_in_group')} />
      <GroupItemsAlignmentOptions />
      <GroupItemsSpacingOptions />
      <ContextualMenuHeadingOption id="on-design-alignment-heading-option" text={window.i18next.t('pmwjs_alignment_on_design')} />
      <ItemAlignmentOptions />
    </ContextualMenu>
  );
}
